import { UserOutlined } from '@ant-design/icons'
import { Avatar, Checkbox } from 'antd'
import Skeleton from 'react-loading-skeleton'

import B2becTranslation from '@/components/B2becTranslation'
import FormatPrice from '@/components/FormatPrice'
import { ReorderIcon } from '@/components/Icons'
import { checkListPriceIsZero } from '@/libs/utils/common'

const tableColumns = (
  addToCartHandler,
  handleCellClick,
  isLoading,
  onCheckHandler,
  comparingProductIds,
  hasAddProductToCartPermission,
  hasProductComparisonPermission,
  shouldHideListPriceGlobally,
) =>
  [
    {
      dataIndex: 'pictureUrl',
      onCell: ({ materialNumber }) => ({
        onClick: () => handleCellClick(materialNumber),
      }),
      width: '10%',
      render: (text) =>
        isLoading
          ? <Skeleton />
          : text
          ? <Avatar shape="square" size={64} src={text} />
          : <Avatar icon={<UserOutlined />} shape="square" size={64} />,
    },
    {
      title: <B2becTranslation value="cart.table.itemNo" />,
      width: '15%',
      dataIndex: 'materialNumber',
      onCell: ({ materialNumber }) => ({
        onClick: () => handleCellClick(materialNumber),
      }),
      render: (text) => (isLoading ? <Skeleton /> : text),
    },
    {
      title: <B2becTranslation value="cart.table.itemName" />,
      dataIndex: 'materialName',
      width: '15%',
      onCell: ({ materialNumber }) => ({
        onClick: () => handleCellClick(materialNumber),
      }),
      render: (text) => (isLoading ? <Skeleton /> : text),
    },
    {
      title: <B2becTranslation value="category" />,
      dataIndex: 'categoryName',
      width: '15%',
      onCell: ({ materialNumber }) => ({
        onClick: () => handleCellClick(materialNumber),
      }),
      render: (text) => (isLoading ? <Skeleton /> : text),
    },
    {
      title: <B2becTranslation value="productComparison.tableColumn.title" />,
      width: '20%',
      dataIndex: 'comparison',
      align: 'left',
      hidden: !hasProductComparisonPermission,
      render: (_, record) => {
        const isComparingProduct = (comparingProductIds ?? []).includes(
          record?.materialNumber,
        )

        return isLoading ? <Skeleton /> : (
          <Checkbox
            checked={isComparingProduct}
            className="kaercher-checkbox"
            onChange={(e) => onCheckHandler(record, e)}
          >
            <B2becTranslation value="productComparison.button" />
          </Checkbox>
        )
      },
    },
    {
      title: (
        <p style={{ marginRight: '40px' }}>
          <B2becTranslation value="productCard.listPrice" />
        </p>
      ),
      dataIndex: 'listPrice',
      align: 'right',
      width: '15%',
      hidden: shouldHideListPriceGlobally,
      onCell: ({ materialNumber }) => ({
        onClick: () => handleCellClick(materialNumber),
      }),
      render: (text, record) => {
        if (isLoading) {
          return <Skeleton />
        }

        const isPriceEqualZero = checkListPriceIsZero(record.listPrice)
        const shouldDisplayListPrice = record?.shouldDisplayListPrice
        const isBProgramProduct = record?.requiresInstruction
        const shouldDisplayAddToCart = record?.displayAddToCart

        const shouldShowOnRequest = isPriceEqualZero
          || !shouldDisplayListPrice
          || (shouldDisplayAddToCart && isBProgramProduct)

        return shouldShowOnRequest
          ? <B2becTranslation value="productCard.onRequest" />
          : <FormatPrice currencyUnit={record?.currencyUnit} price={text} />
      },
    },
    {
      dataIndex: 'materialNumber',
      align: 'right',
      width: '10%',
      render: (_, record) => {
        const isBProgramProduct = record?.requiresInstruction
        const shouldDisplayAddToCart = record?.displayAddToCart && hasAddProductToCartPermission

        const shouldHideAddToCartButton = !shouldDisplayAddToCart
          || isBProgramProduct
          || checkListPriceIsZero(record?.listPrice || record?.price)

        return isLoading ? <Skeleton /> : shouldHideAddToCartButton ? null : (
          <button
            className="button-as-link order-history__btn--reorder"
            type="button"
            onClick={() => addToCartHandler(record.materialNumber)}
          >
            <ReorderIcon />
          </button>
        )
      },
    },
  ].filter((col) => !col.hidden)

export default tableColumns
